import { createContext } from "react";

// set the defaults
const UserContext = createContext({ 
  user: {},
  readOnly: false
});

export default UserContext;